import DefaultPathLengths from '../../../../data/constants/DefaultPathLengths';
function isDefaultPathLength(pathLength, experimentType) {
    return (DefaultPathLengths[experimentType] &&
        pathLength.from === DefaultPathLengths[experimentType].from &&
        pathLength.to === DefaultPathLengths[experimentType].to);
}
export default isDefaultPathLength;
